jQuery.noConflict();
// init page
jQuery(function() {
    initInputs();
	initGallery();
});

//initGallery
function initGallery() {
	jQuery('.promogallery').each(function() {
		var holder = jQuery(this);
		var switcherEls = holder.find('.slideshow-progress-bar > div');
		var highlightBar = holder.find('.highlight-bar');
		var animSpeed = 600;
		
		holder.fadeGallery({
			slides: '.gallery-box > li',
			activeClass:'active',
			pagerLinks: '.slideshow-progress-bar > div',
			circularRotation: true,
			autoRotation: true,
			pauseOnHover: true,
			autoHeight: true,
			switchTime: 5000,
			animSpeed: animSpeed,
			event:'mouseenter',
			onBeforeChange: function(o) {
				highlightBar.animate({
					left: switcherEls.eq(o.currentIndex).position().left
				}, {
					queue: false,
					duration: animSpeed,
					easing: 'linear'
				});
			}
		});
	});
	
	jQuery('.product-section').productGallery({
		zoomHolder: '.zoom-holder',
		zoomStructure: '<div class="zoomPane">\
							<div class="slider zoomDrag">&nbsp;</div>\
						</div>\
						<div class="zoom-box">\
							<a class="min zoomDown" href="#">-</a>\
							<span class="zoom">zoom</span>\
							<a class="max zoomUp" href="#">+</a>\
						</div>',
		visualBox: '.gallery-holder',
		pagerEvent: 'mouseenter click'
	});
}

;(function(jQuery){
	function ProductGallery(options) {
		this.options = jQuery.extend({
			pagerLinks: '.thumbnails li',
			pagerActiveClass: 'active',
			pagerEvent: 'click',
			visualBox: '.visual-box',
			loadingClass: 'loading',
			zoomHolder: false,
			zoomStructure: '<div class="zoomPane">\
								<div class="zoomDrag"></div>\
							</div>\
							<div class="zoomDown"></div>\
							<div class="zoomUp"></div>',
			zoomUp: '.zoomUp',
			zoomDown: '.zoomDown',
			zoomPane: '.zoomPane',
			zoomDrag: '.zoomDrag',
			zoomCoef: 3,
			zoomGrid: 5,
			animSpeed: 200
		}, options);
		this.init();
	}
	ProductGallery.prototype = {
		init: function() {
			this.findElements();
			this.attachEvents();
		},
		findElements: function() {
			this.gallery = jQuery(this.options.holder);
			this.thumbnails = this.gallery.find(this.options.pagerLinks);
			this.visualBox = this.gallery.find(this.options.visualBox);
			this.zoomHolder = this.gallery.find(this.options.zoomHolder);
			this.activeInd = 0;
			this.drag = false;
			this.dragImage = false;
			this.visualBoxWidth = this.visualBox.width();
			this.visualBoxHeight = this.visualBox.height();
			this.vk = this.visualBoxWidth / this.visualBoxHeight;
			this.Czoom = 1;
			this.zoomGrid = 1;
			
			if(this.zoomHolder.length) {
				this.zoomHolder.html(this.options.zoomStructure);
				this.zoomUp = this.zoomHolder.find(this.options.zoomUp);
				this.zoomDown = this.zoomHolder.find(this.options.zoomDown);
				this.zoomPane = this.zoomHolder.find(this.options.zoomPane);
				this.zoomDrag = this.zoomHolder.find(this.options.zoomDrag);
				this.maxLeft = this.zoomPane.width() - this.zoomDrag.width();
			}
		},
		attachEvents: function() {
			this.thumbnails.each(this.bindScope(function(i, obj) {
				var href = jQuery(obj).find('a').attr('href');
				jQuery(obj).bind(this.options.pagerEvent, this.bindScope(function(e) {
					if(!jQuery(obj).hasClass(this.options.pagerActiveClass)) {
						this.activeInd = i;
						this.activeHref = href;
						this.switchSlide();
					}
					e.preventDefault();
				}));
			}));
			this.thumbnails.eq(this.activeInd).trigger(this.options.pagerEvent.split(' ')[0]);
			
			if(this.zoomHolder.length) {
				this.zoomDrag.bind({
					mousedown: this.bindScope(function(e) {
						if(e.which == 1) {
							this.drag = true;
							this.dragStart = e.clientX;
							this.dragLeft = parseInt(this.zoomDrag.css('left'), 10);
							this.maxLeft = this.zoomPane.width() - this.zoomDrag.width();
							this.minLeft = 0;
							this.imgLeft = parseInt(this.newImage.css('left'), 10) + ((this.imgWidth * this.Czoom - this.imgWidth) / 2);
							this.imgTop = parseInt(this.newImage.css('top'), 10) + ((this.imgHeight * this.Czoom - this.imgHeight) / 2);
							return false;
						}
					})
				});
				
				this.zoomUp.bind({
					click: this.bindScope(function(e) {
						if(this.zoomGrid < this.options.zoomGrid) {
							this.zoomGrid++;
							if(this.zoomGrid > this.options.zoomGrid) {
								this.zoomGrid = this.options.zoomGrid
							}
						}
						this.zoomTo();
						e.preventDefault();
					})
				});
				
				this.zoomDown.bind({
					click: this.bindScope(function(e) {
						if(this.zoomGrid > 1) {
							this.zoomGrid--;
							if(this.zoomGrid < 1) {
								this.zoomGrid = 1
							}
						}
						this.zoomTo();
						e.preventDefault();
					})
				});
			}
			
			jQuery(document).bind({
				mousemove: this.bindScope(function(e) {
					if(this.drag) {
						var fl = this.dragLeft + (e.clientX - this.dragStart);
						this.posLeft = fl < this.minLeft ? 0 : fl > this.maxLeft ? this.maxLeft : fl;
						this.zoomDrag.css({
							left: this.posLeft
						});
						this.zoom();
						return false;
					}
					if(this.dragImage) {
						this.posImageLeft = this.dragImageLeft + (e.clientX - this.dragImageStartX);
						this.posImageTop = this.dragImageTop + (e.clientY - this.dragImageStartY);
						this.newImage.css({
							left: this.posImageLeft,
							top: this.posImageTop
						});
						return false;
					}
				}),
				mouseup: this.bindScope(function() {
					this.drag = false;
					this.dragImage = false;
				})
			});
		},
		switchSlide: function() {
			this.gallery.addClass(this.options.loadingClass);
			this.oldImage = this.visualBox.find('img');
			this.oldImage.fadeOut({
				duration: this.options.animSpeed,
				complete: this.bindScope(function() {
					this.oldImage.remove();
				})
			});
			this.newImage = jQuery('<img />', {
				load: this.bindScope(function() {
					this.gallery.removeClass(this.options.loadingClass);
					this.newImage.animate({
						opacity: 1
					}, {
						queue: false,
						duration: this.options.animSpeed
					});
					this.imgWidth = this.newImage.width();
					this.imgHeight = this.newImage.height();
					if(this.zoomHolder.length) {
						this.Czoom = 1;
						this.zoomGrid = 1;
						this.zoomDrag.css({
							left: 0
						});
					}
					this.newImageSetPosition();
				}),
				mousedown: this.bindScope(function(e) {
					if(e.which == 1) {
						this.dragImageStartX = e.clientX;
						this.dragImageStartY = e.clientY;
						this.dragImageLeft = parseInt(this.newImage.css('left'), 10);
						this.dragImageTop = parseInt(this.newImage.css('top'), 10);
						if(this.zoomHolder.length) {
							this.dragImage = true;
							return false;
						}
					}
				}),
				style: '-ms-interpolation-mode: bicubic;'
			}).css({
				opacity: 0,
				top: 0,
				left: 0,
				position: 'absolute',
				width: 'auto',
				height: 'auto',
				cursor: this.zoomHolder.length ? 'move' : 'auto'
			}).appendTo(this.visualBox);
			this.newImage.attr('src', this.activeHref);
			this.thumbnails.removeClass(this.options.pagerActiveClass).eq(this.activeInd).addClass(this.options.pagerActiveClass);
		},
		newImageSetPosition: function() {
			this.VK = this.imgWidth / this.imgHeight;
			if(this.vk <= this.VK) {
				if(this.imgWidth > this.visualBoxWidth) {
					this.imgWidth = this.visualBoxWidth;
					this.imgHeight = this.imgWidth / this.VK;
					
					this.newImage.css({
						width: this.visualBoxWidth,
						top: (this.visualBoxHeight - this.imgHeight) / 2
					});
				}
				else {
					this.newImage.css({
						left: (this.visualBoxWidth - this.imgWidth) / 2,
						top: (this.visualBoxHeight - this.imgHeight) / 2
					});
				}
			}
			else {
				if(this.imgHeight > this.visualBoxHeight) {
					this.imgHeight = this.visualBoxHeight;
					this.imgWidth = this.imgHeight * this.VK;
					
					this.newImage.css({
						width: this.imgHeight * this.VK,
						left: (this.visualBoxWidth - this.imgWidth) / 2
					});
				}
				else {
					this.newImage.css({
						left: (this.visualBoxWidth - this.imgWidth) / 2,
						top: (this.visualBoxHeight - this.imgHeight) / 2
					});
				}
			}
			this.imgLeft = parseInt(this.newImage.css('left'), 10) + ((this.imgWidth * this.Czoom - this.imgWidth) / 2);
			this.imgTop = parseInt(this.newImage.css('top'), 10) + ((this.imgHeight * this.Czoom - this.imgHeight) / 2);
		},
		zoom: function() {
			this.Czoom = this.options.zoomCoef / ((this.options.zoomCoef - 1) * ((this.maxLeft - this.posLeft) / this.maxLeft) + 1);
			this.zoomGrid = Math.floor((this.Czoom / (this.options.zoomCoef)) * (this.options.zoomGrid));
			
			this.newImage.css({
				width: this.imgWidth * this.Czoom,
				height: this.imgHeight * this.Czoom,
				left: this.imgLeft - ((this.imgWidth * this.Czoom - this.imgWidth) / 2),
				top: this.imgTop - ((this.imgHeight * this.Czoom - this.imgHeight) / 2)
			});
		},
		zoomTo: function() {
			this.Czoom = (this.zoomGrid / (this.options.zoomGrid)) * (this.options.zoomCoef);
			if(this.Czoom < 1) {
				this.Czoom = 1
			}
			this.zoomDrag.css({
				left: ((this.zoomGrid - 1) / (this.options.zoomCoef + 1)) * this.maxLeft
			});
			
			this.newImage.css({
				width: this.imgWidth * this.Czoom,
				height: this.imgHeight * this.Czoom,
				left: this.imgLeft - ((this.imgWidth * this.Czoom - this.imgWidth) / 2),
				top: this.imgTop - ((this.imgHeight * this.Czoom - this.imgHeight) / 2)
			});
		},
		bindScope: function(func, scope) {
			return jQuery.proxy(func, scope || this);
		},
		makeCallback: function(name, args) {
			if(typeof this.options[name] === 'function') {
				this.options[name].apply(this, args);
			}
		}
	}
	
	// jquery plugin
	jQuery.fn.productGallery = function(opt){
		return this.each(function(){
			jQuery(this).data('ProductGallery', new ProductGallery(jQuery.extend(opt,{holder:this})));
		});
	}
}(jQuery));

// clear inputs on focus
function initInputs() {
	// replace options
	var opt = {
		clearInputs: true,
		clearTextareas: true,
		clearPasswords: true
	}
	// collect all items
	var inputs = [].concat(
		PlaceholderInput.convertToArray(document.getElementsByTagName('input')),
		PlaceholderInput.convertToArray(document.getElementsByTagName('textarea'))
	);
	// apply placeholder class on inputs
	for(var i = 0; i < inputs.length; i++) {
		if(inputs[i].className.indexOf('default') < 0) {
			var inputType = PlaceholderInput.getInputType(inputs[i]);
			if((opt.clearInputs && inputType === 'text') ||
				(opt.clearTextareas && inputType === 'textarea') || 
				(opt.clearPasswords && inputType === 'password')
			) {
				new PlaceholderInput({
					element:inputs[i],
					wrapWithElement:false,
					showUntilTyping:false,
					getParentByClass:false,
					placeholderAttr:'value'
				});
			}
		}
	}
}

// input type placeholder class
;(function(){
	PlaceholderInput = function() {
		this.options = {
			element:null,
			showUntilTyping:false,
			wrapWithElement:false,
			getParentByClass:false,
			placeholderAttr:'value',
			inputFocusClass:'focus',
			inputActiveClass:'text-active',
			parentFocusClass:'parent-focus',
			parentActiveClass:'parent-active',
			labelFocusClass:'label-focus',
			labelActiveClass:'label-active',
			fakeElementClass:'input-placeholder-text'
		}
		this.init.apply(this,arguments);
	}
	PlaceholderInput.convertToArray = function(collection) {
		var arr = [];
		for (var i = 0, ref = arr.length = collection.length; i < ref; i++) {
		 arr[i] = collection[i];
		}
		return arr;
	}
	PlaceholderInput.getInputType = function(input) {
		return (input.type ? input.type : input.tagName).toLowerCase();
	}
	PlaceholderInput.prototype = {
		init: function(opt) {
			this.setOptions(opt);
			if(this.element && this.element.PlaceholderInst) {
				this.element.PlaceholderInst.refreshClasses();
			} else {
				this.element.PlaceholderInst = this;
				if(this.elementType == 'text' || this.elementType == 'password' || this.elementType == 'textarea') {
					this.initElements();
					this.attachEvents();
					this.refreshClasses();
				}
			}
		},
		setOptions: function(opt) {
			for(var p in opt) {
				if(opt.hasOwnProperty(p)) {
					this.options[p] = opt[p];
				}
			}
			if(this.options.element) {
				this.element = this.options.element;
				this.elementType = PlaceholderInput.getInputType(this.element);
				this.wrapWithElement = (this.elementType === 'password' || this.options.showUntilTyping ? true : this.options.wrapWithElement);
				this.setOrigValue( this.options.placeholderAttr == 'value' ? this.element.defaultValue : this.element.getAttribute(this.options.placeholderAttr) );
			}
		},
		setOrigValue: function(value) {
			this.origValue = value;
		},
		initElements: function() {
			// create fake element if needed
			if(this.wrapWithElement) {
				this.element.value = '';
				this.element.removeAttribute(this.options.placeholderAttr);
				this.fakeElement = document.createElement('span');
				this.fakeElement.className = this.options.fakeElementClass;
				this.fakeElement.innerHTML += this.origValue;
				this.fakeElement.style.color = getStyle(this.element, 'color');
				this.fakeElement.style.position = 'absolute';
				this.element.parentNode.insertBefore(this.fakeElement, this.element);
			}
			// get input label
			if(this.element.id) {
				this.labels = document.getElementsByTagName('label');
				for(var i = 0; i < this.labels.length; i++) {
					if(this.labels[i].htmlFor === this.element.id) {
						this.labelFor = this.labels[i];
						break;
					}
				}
			}
			// get parent node (or parentNode by className)
			this.elementParent = this.element.parentNode;
			if(typeof this.options.getParentByClass === 'string') {
				var el = this.element;
				while(el.parentNode) {
					if(hasClass(el.parentNode, this.options.getParentByClass)) {
						this.elementParent = el.parentNode;
						break;
					} else {
						el = el.parentNode;
					}
				}
			}
		},
		attachEvents: function() {
			this.element.onfocus = bindScope(this.focusHandler, this);
			this.element.onblur = bindScope(this.blurHandler, this);
			if(this.options.showUntilTyping) {
				this.element.onkeydown = bindScope(this.typingHandler, this);
				this.element.onpaste = bindScope(this.typingHandler, this);
			}
			if(this.wrapWithElement) this.fakeElement.onclick = bindScope(this.focusSetter, this);
		},
		togglePlaceholderText: function(state) {
			if(this.wrapWithElement) {
				this.fakeElement.style.display = state ? '' : 'none';
			} else {
				this.element.value = state ? this.origValue : '';
			}
		},
		focusSetter: function() {
			this.element.focus();
		},
		focusHandler: function() {
			this.focused = true;
			if(!this.element.value.length || this.element.value === this.origValue) {
				if(!this.options.showUntilTyping) {
					this.togglePlaceholderText(false);
				}
			}
			this.refreshClasses();
		},
		blurHandler: function() {
			this.focused = false;
			if(!this.element.value.length || this.element.value === this.origValue) {
				this.togglePlaceholderText(true);
			}
			this.refreshClasses();
		},
		typingHandler: function() {
			setTimeout(bindScope(function(){
				if(this.element.value.length) {
					this.togglePlaceholderText(false);
					this.refreshClasses();
				}
			},this), 10);
		},
		refreshClasses: function() {
			this.textActive = this.focused || (this.element.value.length && this.element.value !== this.origValue);
			this.setStateClass(this.element, this.options.inputFocusClass,this.focused);
			this.setStateClass(this.elementParent, this.options.parentFocusClass,this.focused);
			this.setStateClass(this.labelFor, this.options.labelFocusClass,this.focused);
			this.setStateClass(this.element, this.options.inputActiveClass, this.textActive);
			this.setStateClass(this.elementParent, this.options.parentActiveClass, this.textActive);
			this.setStateClass(this.labelFor, this.options.labelActiveClass, this.textActive);
		},
		setStateClass: function(el,cls,state) {
			if(!el) return; else if(state) addClass(el,cls); else removeClass(el,cls);
		}
	}
	
	// utility functions
	function hasClass(el,cls) {
		return el.className ? el.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)')) : false;
	}
	function addClass(el,cls) {
		if (!hasClass(el,cls)) el.className += " "+cls;
	}
	function removeClass(el,cls) {
		if (hasClass(el,cls)) {el.className=el.className.replace(new RegExp('(\\s|^)'+cls+'(\\s|$)'),' ');}
	}
	function bindScope(f, scope) {
		return function() {return f.apply(scope, arguments)}
	}
	function getStyle(el, prop) {
		if (document.defaultView && document.defaultView.getComputedStyle) {
			return document.defaultView.getComputedStyle(el, null)[prop];
		} else if (el.currentStyle) {
			return el.currentStyle[prop];
		} else {
			return el.style[prop];
		}
	}
}());

/*
 * jQuery SlideShow plugin
 */
;(function(jQuery){
	function FadeGallery(options) {
		this.options = jQuery.extend({
			slides: 'ul.slideset > li',
			activeClass:'active',
			disabledClass:'disabled',
			btnPrev: 'a.btn-prev',
			btnNext: 'a.btn-next',
			generatePagination: false,
			pagerList: '<ul>',
			pagerListItem: '<li><a href="#"></a></li>',
			pagerListItemText: 'a',
			pagerLinks: '.pagination li',
			currentNumber: 'span.current-num',
			totalNumber: 'span.total-num',
			btnPlay: '.btn-play',
			btnPause: '.btn-pause',
			btnPlayPause: '.btn-play-pause',
			autorotationActiveClass: 'autorotation-active',
			autorotationDisabledClass: 'autorotation-disabled',
			circularRotation: true,
			switchSimultaneously: true,
			disableWhileAnimating: false,
			autoRotation: false,
			pauseOnHover: true,
			autoHeight: false,
			switchTime: 4000,
			animSpeed: 600,
			event:'click'
		}, options);
		this.init();
	}
	FadeGallery.prototype = {
		init: function() {
			if(this.options.holder) {
				this.findElements();
				this.initStructure();
				this.attachEvents();
				this.refreshState(true);
				this.autoRotate();
			}
		},
		findElements: function() {
			// control elements
			this.gallery = jQuery(this.options.holder);
			this.slides = this.gallery.find(this.options.slides);
			this.slidesHolder = this.slides.eq(0).parent();
			this.stepsCount = this.slides.length;
			this.btnPrev = this.gallery.find(this.options.btnPrev);
			this.btnNext = this.gallery.find(this.options.btnNext);
			this.currentIndex = 0;
			
			// create gallery pagination
			if(typeof this.options.generatePagination === 'string') {
				this.pagerHolder = this.gallery.find(this.options.generatePagination).empty();
				this.pagerList = jQuery(this.options.pagerList).appendTo(this.pagerHolder);
				for(var i = 0; i < this.stepsCount; i++) {
					jQuery(this.options.pagerListItem).appendTo(this.pagerList).find(this.options.pagerListItemText).text(i+1);
				}
				this.pagerLinks = this.pagerList.children();
			} else {
				this.pagerLinks = this.gallery.find(this.options.pagerLinks);
			}
			
			// get start index
			var activeSlide = this.slides.filter('.'+this.options.activeClass);
			if(activeSlide.length) {
				this.currentIndex = this.slides.index(activeSlide);
			}
			this.prevIndex = this.currentIndex;
			
			// autorotation control buttons
			this.btnPlay = this.gallery.find(this.options.btnPlay);
			this.btnPause = this.gallery.find(this.options.btnPause);
			this.btnPlayPause = this.gallery.find(this.options.btnPlayPause);
			
			// misc elements
			this.curNum = this.gallery.find(this.options.currentNumber);
			this.allNum = this.gallery.find(this.options.totalNumber);
		},
		initStructure: function() {
			this.slides.css({display:'block',opacity:0}).eq(this.currentIndex).css({
				opacity:''
			});
		},
		attachEvents: function() {
			this.btnPrev.bind(this.options.event, this.bindScope(function(e){
				this.prevSlide();
				e.preventDefault();
			}));
			this.btnNext.bind(this.options.event, this.bindScope(function(e){
				this.nextSlide();
				e.preventDefault();
			}));
			this.pagerLinks.each(this.bindScope(function(ind, obj){
				jQuery(obj).bind(this.options.event, this.bindScope(function(){
					this.numSlide(ind);
					return false;
				}));
			}));
			
			// autorotation buttons handler
			this.btnPlay.bind(this.options.event, this.bindScope(this.startRotation));
			this.btnPause.bind(this.options.event, this.bindScope(this.stopRotation));
			this.btnPlayPause.bind(this.options.event, this.bindScope(function(){
				if(!this.gallery.hasClass(this.options.autorotationActiveClass)) {
					this.startRotation();
				} else {
					this.stopRotation();
				}
			}));
			
			// pause on hover handling
			if(this.options.pauseOnHover) {
				this.gallery.hover(this.bindScope(function(){
					if(this.options.autoRotation) {
						this.galleryHover = true;
						this.pauseRotation();
					}
				}), this.bindScope(function(){
					if(this.options.autoRotation) {
						this.galleryHover = false;
						this.resumeRotation();
					}
				}));
			}
		},
		prevSlide: function() {
			if(!(this.options.disableWhileAnimating && this.galleryAnimating)) {
				this.prevIndex = this.currentIndex;
				if(this.currentIndex > 0) {
					this.currentIndex--;
					this.switchSlide();
				} else if(this.options.circularRotation) {
					this.currentIndex = this.stepsCount - 1;
					this.switchSlide();
				}
			}
		},
		nextSlide: function(fromAutoRotation) {
			if(!(this.options.disableWhileAnimating && this.galleryAnimating)) {
				this.prevIndex = this.currentIndex;
				if(this.currentIndex < this.stepsCount - 1) {
					this.currentIndex++;
					this.switchSlide();
				} else if(this.options.circularRotation || fromAutoRotation === true) {
					this.currentIndex = 0;
					this.switchSlide();
				}
			}
		},
		numSlide: function(c) {
			if(this.currentIndex != c) {
				this.prevIndex = this.currentIndex;
				this.currentIndex = c;
				this.switchSlide();
			}
		},
		switchSlide: function() {
			this.galleryAnimating = true;
			this.slides.eq(this.prevIndex).stop().animate({opacity:0},{duration: this.options.animSpeed, complete: this.bindScope(function(){
				this.slides.eq(this.prevIndex).css({opacity:0});
			})});
			clearTimeout(this.switchTimer);
			this.switchTimer = setTimeout(this.bindScope(function(){
				this.slides.eq(this.currentIndex).stop().animate({opacity:1},{duration: this.options.animSpeed, complete: this.bindScope(function(){
					this.slides.eq(this.currentIndex).css({opacity:''});
					this.galleryAnimating = false;
					this.makeCallback('onChange', [this]);
					this.autoRotate();
				})});
				
			}), this.options.switchSimultaneously ? 1 : this.options.animSpeed);
			this.refreshState();
			this.makeCallback('onBeforeChange', [this]);
		},
		refreshState: function(initial) {
			this.slides.removeClass(this.options.activeClass).eq(this.currentIndex).addClass(this.options.activeClass);
			this.pagerLinks.removeClass(this.options.activeClass).eq(this.currentIndex).addClass(this.options.activeClass);
			this.curNum.html(this.currentIndex+1);
			this.allNum.html(this.stepsCount);
			
			// initial refresh
			if(initial) {
				if(this.options.autoHeight) {
					this.slidesHolder.css({height: this.slides.eq(this.currentIndex).outerHeight(true) });
				}
			} else {
				if(this.options.autoHeight) {
					this.slidesHolder.stop().animate({height: this.slides.eq(this.currentIndex).outerHeight(true) });
				}
			}
			
			// disabled state
			if(!this.options.circularRotation) {
				this.btnPrev.add(this.btnNext).removeClass(this.options.disabledClass);
				if(this.currentIndex === 0) this.btnPrev.addClass(this.options.disabledClass);
				if(this.currentIndex === this.stepsCount - 1) this.btnNext.addClass(this.options.disabledClass);
			}
		},
		startRotation: function() {
			this.options.autoRotation = true;
			this.galleryHover = false;
			this.autoRotationStopped = false;
			this.resumeRotation();
		},
		stopRotation: function() {
			this.galleryHover = true;
			this.autoRotationStopped = true;
			this.pauseRotation();
		},
		pauseRotation: function() {
			this.gallery.addClass(this.options.autorotationDisabledClass);
			this.gallery.removeClass(this.options.autorotationActiveClass);
			clearTimeout(this.timer);
		},
		resumeRotation: function() {
			if(!this.autoRotationStopped) {
				this.gallery.addClass(this.options.autorotationActiveClass);
				this.gallery.removeClass(this.options.autorotationDisabledClass);
				this.autoRotate();
			}
		},
		autoRotate: function() {
			clearTimeout(this.timer);
			if(this.options.autoRotation && !this.galleryHover && !this.autoRotationStopped) {
				this.timer = setTimeout(this.bindScope(function(){
					this.nextSlide(true);
				}), this.options.switchTime);
			} else {
				this.pauseRotation();
			}
		},
		bindScope: function(func, scope) {
			return jQuery.proxy(func, scope || this);
		},
		makeCallback: function(name, args) {
			if(typeof this.options[name] === 'function') {
				this.options[name].apply(this, args);
			}
		}
	}

	// jquery plugin
	jQuery.fn.fadeGallery = function(opt){
		return this.each(function(){
			jQuery(this).data('FadeGallery', new FadeGallery(jQuery.extend(opt,{holder:this})));
		});
	}
}(jQuery));